import {
  GET_AMBULANCE_REQUESTS,
  GET_AMBULANCE_BY_ID,
  CREATE_AMBULANCE_REQUEST,
  UPDATE_AMBULANCE_REQUEST,
  DELETE_AMBULANCE_REQUEST,
} from "../actions/types";

const initialState = {
  ambulanceList: [],
  selectedAmbulance: {},
  saveStatus: null,
  updateStatus: null,
  deleteStatus: null,
};

export default function frontofficeambulanceReducer(state = initialState, action) { 
  switch (action.type) {
    case GET_AMBULANCE_REQUESTS:
      return {
        ...state,
        ambulanceList: action.payload.data,
      };

    case GET_AMBULANCE_BY_ID:
      return {
        ...state,
        selectedAmbulance: action.payload.data,
      };

    case CREATE_AMBULANCE_REQUEST:
      return {
        ...state,
        saveStatus: action.payload.success,
      };

    case UPDATE_AMBULANCE_REQUEST:
      return {
        ...state,
        updateStatus: action.payload.success,
      };

    case DELETE_AMBULANCE_REQUEST:
      return {
        ...state,
        deleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}